/**
 * Arquivo: src/services/api.ts
 * Versão: 6.0.0
 * Data: 08/10/2026
 * Descrição: cliente central autenticado para o Worker do Controle Financeiro.
 */
import { neonAuth } from './neonAuth'

const API = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '')

async function authHeaders(extra: Record<string,string> = {}) {
  const token=await neonAuth.getAccessToken()
  if(!token)throw new Error('Sessão expirada. Entre novamente.')
  return {Authorization:`Bearer ${token}`,...extra}
}

const readsInFlight = new Map<string, Promise<any>>()

export async function apiJson(path:string, init:RequestInit={}) {
  if (!API) throw new Error('Backend ainda não configurado. Defina VITE_API_URL no .env.')
  const headers = await authHeaders(init.headers as Record<string,string> || {})
  const canShare = (!init.method || init.method === 'GET') && !init.signal && !init.body
  if (init.method && init.method !== 'GET') readsInFlight.clear()
  const key = canShare ? `${headers.Authorization}:${path}` : ''
  if (canShare && readsInFlight.has(key)) return readsInFlight.get(key)
  const request = (async () => {
    const res = await fetch(`${API}${path}`, { ...init, headers })
    const body = await res.json().catch(()=>({}))
    if (!res.ok) throw new Error(body?.error || 'Falha ao acessar o backend.')
    return body
  })()
  if (canShare) readsInFlight.set(key, request)
  try { return await request }
  finally { if (readsInFlight.get(key) === request) readsInFlight.delete(key) }
}

export async function apiBlob(path:string) {
  if (!API) throw new Error('Backend ainda não configurado. Defina VITE_API_URL no .env.')
  const headers = await authHeaders()
  const res = await fetch(`${API}${path}`, { headers })
  if (!res.ok) {
    const body = await res.json().catch(()=>({}))
    throw new Error(body?.error || 'Não foi possível abrir o arquivo.')
  }
  return res.blob()
}

